import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 64px - 62px);
`;

const PDI = () => {
  return (
    <>
      <Helmet title="PDI" />

      <Container>
        <iframe
          src="https://datastudio.google.com/embed/reporting/b40263bb-23cc-4694-b102-960ecd69df27/page/V0aiC"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          title="PDI"
        />
      </Container>
    </>
  );
};

export default PDI;
